import { Icon } from './Icon';

/**
 * Rating row. The visible stars are decorative — the numeric value is announced
 * once via aria-label rather than as five separate images.
 */
export function Stars({ value = 5, max = 5, size = 20, className }) {
  return (
    <span
      className={className}
      role="img"
      aria-label={`${value} out of ${max} stars`}
      style={{ display: 'inline-flex', gap: 2, color: 'var(--amber-500)' }}
    >
      {Array.from({ length: max }, (_, i) => {
        const filled = value - i;
        if (filled >= 1) return <Icon key={i} name="star" size={size} />;
        if (filled >= 0.25) return <Icon key={i} name="star-half" size={size} />;
        return <Icon key={i} name="star" size={size} style={{ color: 'var(--ink-200)' }} />;
      })}
    </span>
  );
}
